import React from "react";

//style
import styles from "./TableRow.module.scss";
import cx from "classnames";
import classNames from "classnames";

interface ITableRowProps {
    className?: string;
}

const TableRow: React.FC<ITableRowProps> = (props) => {
    return (
        <tr
            className={cx([
                styles["tablelist-row"],
                {
                    [props.className]: !!classNames
                }
            ])}>
            {props.children}
        </tr>
    );
};

export default TableRow;
